import storage, { AppContext } from 'context/store';

export default function Provider({ children }) {
  const value = storage();

  return <AppContext.Provider value={{ ...value }}>{children}</AppContext.Provider>;
}
